import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
  AdminCreateUserInput,
  AdminUpdateCaseInput,
  AdminUpdateUserInput,
} from '@casetrace/shared';
import { adminCreateUser, adminUpdateCase, adminUpdateUser } from '../lib/callables';

export function useAdminActions() {
  const queryClient = useQueryClient();
  const invalidateOverview = () => {
    queryClient.invalidateQueries({ queryKey: ['admin-overview'] });
    queryClient.invalidateQueries({ queryKey: ['admin-activity'] });
  };

  return {
    createUser: useMutation({
      mutationFn: (input: AdminCreateUserInput) => adminCreateUser(input),
      onSuccess: invalidateOverview,
    }),
    updateUser: useMutation({
      mutationFn: (input: AdminUpdateUserInput) => adminUpdateUser(input),
      onSuccess: invalidateOverview,
    }),
    updateCase: useMutation({
      mutationFn: (input: AdminUpdateCaseInput) => adminUpdateCase(input),
      onSuccess: invalidateOverview,
    }),
  };
}
